{
  "audit": {
    "title": "User audit logs"
  }
}